import CommentActionTypes from "./comment.types";

export const fetchCommentsStart = (reportId) => ({
  type: CommentActionTypes.FETCH_COMMENTS_START,
  payload: reportId,
});

export const fetchCommentsSuccess = (commentItems) => ({
  type: CommentActionTypes.FETCH_COMMENTS_SUCCESS,
  payload: commentItems,
});

export const fetchCommentsFailure = (errorMessage) => ({
  type: CommentActionTypes.FETCH_COMMENTS_FAILURE,
  payload: errorMessage,
});

export const createCommentStart = (comment) => ({
  type: CommentActionTypes.CREATE_COMMENT_START,
  payload: comment,
});

export const createCommentSuccess = () => ({
  type: CommentActionTypes.CREATE_COMMENT_SUCCESS,
});

export const createCommentFailure = (errorMessage) => ({
  type: CommentActionTypes.CREATE_COMMENT_FAILURE,
  payload: errorMessage,
});
